import { render, staticRenderFns } from "./FmSwitchDemo.vue?vue&type=template&id=e7b4b704&scoped=true&"
import script from "./FmSwitchDemo.vue?vue&type=script&lang=js&"
export * from "./FmSwitchDemo.vue?vue&type=script&lang=js&"
import style0 from "./FmSwitchDemo.vue?vue&type=style&index=0&id=e7b4b704&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b4b704",
  null
  
)

export default component.exports